import { render, staticRenderFns } from "./IndexMultiple.vue?vue&type=template&id=64e94b72&"
import script from "./IndexMultiple.vue?vue&type=script&lang=js&"
export * from "./IndexMultiple.vue?vue&type=script&lang=js&"
import style0 from "./IndexMultiple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports